import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const technologicalTransferProofApi = generateProofApi('/proof-file/technological-transfer');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('technological-transfer', technologicalTransferProofApi);

export function getTechnologicalTransferProofsByOwnerOptions(
  technologicalTransferId: Id,
  userId: Id,
): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(technologicalTransferId, userId);
}

export function getTechnologicalTransferProofsOptions(technologicalTransferId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(technologicalTransferId);
}

export function useUploadOrUpdateTechnologicalTransferProof(technologicalTransferId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(technologicalTransferId, queryClient));
}

export function useDeleteTechnologicalTransferProof(technologicalTransferId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(technologicalTransferId, queryClient));
}
